<script>
import Layout from '@layouts/main';
import BlockingContainer from '@components/BlockingContainer';
import FileDownloadLink from '@components/FileDownloadLink';
import { DateTime } from 'luxon';
import NewsRecordModel from '@models/NewsRecord';
import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer';
import Vue from 'vue';
Vue.use(Viewer);

export default {
  components: {
    Layout,
    BlockingContainer,
    FileDownloadLink,
  },
  page() {
    return {
      title: this.$t('titles.news'),
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('titles.news'),
          to: { name: 'news.index' },
        },
        {
          text: this.$t('titles.view_news'),
          to: { name: 'news.index' },
        },
      ],
      newsRecord: {
        title: '',
        content: '',
        created_at: null,
        images: [],
        attachment: null,
      },
      options: {
        url: 'data-source',
      },
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.$wait.start('news processing');
      NewsRecordModel.find(this.$route.params.id)
        .then((response) => {
          this.newsRecord = Object.assign({}, this.newsRecord, response);
          this.$wait.end('news processing');
        })
        .catch(() => this.$wait.end('news processing'));
    }
  },
  methods: {
    formatDate(value) {
      return DateTime.fromSQL(value).toFormat('dd.MM.yyyy HH:mm');
    },
  },
};
</script>

<template>
  <Layout>
    <b-breadcrumb :items="breadcrumbItems" />
    <BlockingContainer v-if="$wait.is('news processing')"></BlockingContainer>
    <b-card
      v-if="newsRecord.title != ''"
      :border-variant="!errors.items.length ? 'dark' : 'danger'"
      :header="newsRecord.title"
      header-tag="header"
      :header-bg-variant="!errors.items.length ? 'dark' : 'danger'"
      header-text-variant="white"
      class="mb-3"
    >
      <b-row v-viewer="options">
        <b-col v-for="image in newsRecord.images" :key="`image-${image.id}`" sm="2">
          <b-img-lazy class="pointer mb-sm-0 mb-2" thumbnail fluid :src="image.small" :data-source="image.large" />
        </b-col>
      </b-row>
      <hr v-if="newsRecord.images" />
      <b-form-row class="mt-2 mb-2">
        <b-col>
          <!-- eslint-disable -->
          <div class="user-formatted-text" v-html="newsRecord.content"></div>
        </b-col>
      </b-form-row>
      <b-form-row v-if="newsRecord.attachment" class="mb-2">
        <b-col>
          <br/>
          <span>{{ $t('table_labels.attachment') }}: </span>
          <FileDownloadLink :file="newsRecord.attachment" :removable="false" />
        </b-col>
      </b-form-row>
      <b-row>
        <b-col class="text-right">
          <b-form-text>{{ formatDate(newsRecord.created_at) }}</b-form-text>
        </b-col>
      </b-row>
    </b-card>
  </Layout>
</template>
<style lang="scss" scoped>

.user-formatted-text {
  white-space: pre-line;
}

</style>
